import Router from 'next/router';
import React, { forwardRef, RefObject, useEffect, useState } from 'react';

import { FormControl, TextInput } from '@sravni/react-design-system';
import { ArrowLeft, Cross, Search } from '@sravni/react-icons';
import { useIsMobile, useStyles } from '@sravni/react-utils';

import { SEARCH } from '../../../../../../constants/routes';
import { MAX_SEARCH_INPUT, TYPE_VALUES } from '../../../../../../constants/search';
import { createLinkProps } from '../../../../../../utils/routing';

import styles from './search-input.module.scss';

interface IProps {
  handleBlur?: () => void;
  topBlock?: boolean;
  menuBlock?: boolean;
  topBlockActive?: boolean;
  toggleOverlay?: (value: 'on' | 'off') => void;
}

export const SearchInput = forwardRef(
  ({ handleBlur, topBlock, menuBlock, topBlockActive, toggleOverlay }: IProps, ref: RefObject<HTMLInputElement>) => {
    const isMobile = useIsMobile();
    const cx = useStyles(styles);

    const [text, setText] = useState('');

    const invalidText = text.length > MAX_SEARCH_INPUT;

    useEffect(() => {
      if (!topBlockActive) setText('');
    }, [topBlockActive]);

    const showControls = !topBlock || topBlockActive;

    const { href, as } = createLinkProps('search', SEARCH, {
      queryParams: {
        text,
        searchType: TYPE_VALUES.NEWS,
      },
    });

    const handleTextChange = (e) => {
      setText(e.target.value);
    };

    const handleDeleteText = () => {
      handleBlur && handleBlur();
      setText('');
    };

    const handleKeyDown = (event) => {
      if (!invalidText && event.key === 'Enter') {
        Router.push(href, as);
        toggleOverlay && toggleOverlay('off');
      }
    };

    const onBlur = () => {
      handleBlur && handleBlur();
      setText('');
    };

    const handleBackClick = (e) => {
      e.stopPropagation();
      toggleOverlay('off');
    };

    return (
      <div className={cx('searchWrapper', topBlock && 'searchWrapperTop', menuBlock && 'searchWrapperMenu')}>
        <FormControl invalid={invalidText}>
          <TextInput
            className={styles.searchInput}
            placeholder={isMobile ? 'Поиск по Журналу' : 'Что ищете?'}
            autoFocus={!isMobile}
            value={text}
            onChange={handleTextChange}
            onBlur={onBlur}
            onKeyDown={handleKeyDown}
            icon={showControls ? <Cross /> : null}
            leftIcon={showControls ? topBlock ? <ArrowLeft /> : <Search /> : null}
            ref={ref}
          />
          {invalidText && <FormControl.HelperText>Максимум {MAX_SEARCH_INPUT} символов</FormControl.HelperText>}
        </FormControl>
        {topBlockActive && <div className={styles.backButton} onClick={handleBackClick} />}
        {showControls && <div className={styles.deleteButton} onClick={handleDeleteText} />}
      </div>
    );
  },
);

SearchInput.displayName = 'SearchInput';
